
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.6 47.6"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#D19DA5","cx":"23.8","cy":"23.8","r":"23.3"}}),_c('path',{attrs:{"fill":"#FFF","d":"M23.8 1c12.6 0 22.8 10.2 22.8 22.8S36.4 46.6 23.8 46.6 1 36.4 1 23.8 11.2 1 23.8 1m0-1C10.7 0 0 10.7 0 23.8s10.7 23.8 23.8 23.8S47.6 37 47.6 23.8 37 0 23.8 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M24.2 8.2L13 24.2l11.2 16 11.2-16m-18.496 0L24.2 13.8l7.296 10.4L24.2 34.6"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/objectIcons/virtual.svg